export default __webpack_public_path__ + "910bd068899391490681b9386539a6a1.png";